<form data-testid="payments-edit-modal-form" class="filter" [formGroup]="dynamicFormGroup!" (submit)="updateAmounts()">
  <modal-panel title="Bookings" (close)="closeModal()" data-testid="payments-edit-modal-panel" class="filter-panel">
    <div class="filter__fields" [ngClass]="{ 'loading-spinner': !loadedData || !dataSource.length }">
      <ng-container *ngIf="!loadedData; else loadedContent">
        <mat-spinner data-testid="payments-edit-modal-panel-loading-spinner"></mat-spinner>
      </ng-container>

      <ng-template #loadedContent>
        <div class="clients-modal-container mat-elevation-z8" data-testid="payments-edit-modal-panel-container">
          <mat-table [dataSource]="dataSource" matSort data-testid="payments-edit-modal-panel-table" class="responsive-table">

            <ng-container matColumnDef="adxInvoiceId">
              <mat-header-cell class="mat-header-cell" *matHeaderCellDef data-testid="payments-edit-invoice-id-header">Invoice Number</mat-header-cell>
              <mat-cell *matCellDef="let payment" data-testid="payments-edit-invoice-id-cell">{{ payment.adxInvoiceId }}</mat-cell>
            </ng-container>

            <ng-container matColumnDef="adxBookingId">
              <mat-header-cell class="mat-header-cell" *matHeaderCellDef data-testid="payments-edit-adx-booking-id-header">Booking Number</mat-header-cell>
              <mat-cell *matCellDef="let payment" data-testid="payments-edit-adx-booking-id-cell">{{ payment.adxBookingId }}</mat-cell>
            </ng-container>

            <ng-container matColumnDef="adxBookingTravelTypeName">
              <mat-header-cell class="mat-header-cell" *matHeaderCellDef data-testid="payments-edit-adx-booking-travel-type-name-header">Travel Type</mat-header-cell>
              <mat-cell *matCellDef="let payment" data-testid="payments-edit-adx-booking-travel-type-name-cell">{{ payment.adxBookingTravelTypeName }}</mat-cell>
            </ng-container>

            <ng-container matColumnDef="adxBookingVendorName">
              <mat-header-cell class="mat-header-cell" *matHeaderCellDef data-testid="payments-edit-adx-booking-vendor-name-header">Vendor Name</mat-header-cell>
              <mat-cell *matCellDef="let payment" data-testid="payments-edit-adx-booking-vendor-name-cell">{{ payment.adxBookingVendorName }}</mat-cell>
            </ng-container>

            <ng-container matColumnDef="totalFare">
              <mat-header-cell class="mat-header-cell" *matHeaderCellDef data-testid="payments-edit-amount-header">Total Fare</mat-header-cell>
              <mat-cell *matCellDef="let payment" class="responsive-cell" data-testid="payments-edit-amount-cell">
                <mat-form-field floatLabel="always" class="responsive-form-field">
                  <mat-label></mat-label>
                  <input matInput placeholder="{{ payment.totalFare }}" [formControlName]="formControlNames[payment.adxBookingId].totalFare" appDecimalInput  />
                </mat-form-field>
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="vendorPaymentMadeAmt">
              <mat-header-cell class="mat-header-cell" *matHeaderCellDef data-testid="vendor-payment-made-edit-amount-header">Vendor Made Payment</mat-header-cell>
              <mat-cell *matCellDef="let payment" class="responsive-cell" data-testid="vendor-payment-made-edit-amount-cell">
                <mat-form-field floatLabel="always" class="responsive-form-field">
                  <mat-label></mat-label>
                  <input matInput placeholder="{{ payment.vendorPaymentMadeAmt }}" [formControlName]="formControlNames[payment.adxBookingId].vendorPaymentMadeAmt" appDecimalInput />
                </mat-form-field>
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="clientPaymentReceivedAmt">
              <mat-header-cell class="mat-header-cell" *matHeaderCellDef data-testid="client-payment-received-edit-amount-header">Client Received Payment</mat-header-cell>
              <mat-cell *matCellDef="let payment" class="responsive-cell" data-testid="vendor-payment-made-edit-amount-cell">
                <mat-form-field floatLabel="always" class="responsive-form-field">
                  <mat-label></mat-label>
                  <input matInput placeholder="{{ payment.clientPaymentReceivedAmt }}" [formControlName]="formControlNames[payment.adxBookingId].clientPaymentReceivedAmt" appDecimalInput />
                </mat-form-field>
              </mat-cell>
            </ng-container>

            <mat-header-row *matHeaderRowDef="displayedColumns" data-testid="payments-edit-modal-header-row"></mat-header-row>
            <mat-row *matRowDef="let row; columns: displayedColumns;" data-testid="payments-edit-modal-list-row"></mat-row>

          </mat-table>

          <mat-paginator [length]="pagination.totalItemCount"
                         [hidePageSize]="true"
                         [pageSize]="pagination.pageSize"
                         [pageIndex]="pagination.pageIndex"
                         (page)="handlePageChanged($event)"
                         data-testid="payments-edit-modal-paginator">
          </mat-paginator>
        </div>
      </ng-template>
    </div>

    <ng-container modalPanelFooter data-testid="payments-edit-modal-panel-footer">
      <div class="modal-footer">
        <button mat-button mat-stroked-button color="primary" type="button" (click)="closeModal()" data-testid="payments-edit-modal-panel-close-button">
          Close
        </button>

        <ng-container *ngIf="loadedData && dataSource.length">
          <button mat-raised-button color="primary" type="submit" [disabled]="isDisabled()" data-testid="payments-edit-modal-submit-button">
            <ng-container *ngIf="!submitedData; else submitText">
              <mat-spinner color="accent" diameter="30"></mat-spinner>
            </ng-container>
            <ng-template #submitText>Submit</ng-template>
          </button>
        </ng-container>
      </div>
    </ng-container>
  </modal-panel>
</form>
